/**
 * @generated SignedSource<<10025db47cc41fef55138624b49beabf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type IssueFieldVisibility = "ALL" | "ORG_ONLY" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PendingIssueSuggestionState = "APPLIED" | "PENDING" | "REJECTED" | "%future added value";
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueViewerIssue$data = {
  readonly agentAssignments: ReadonlyArray<{
    readonly __typename: "AgentAssignment";
    readonly assignee: {
      readonly avatarUrl: string;
      readonly displayName: string;
      readonly id: string;
      readonly isAgent: boolean;
      readonly isCopilot: boolean;
      readonly login: string;
    } | null | undefined;
    readonly assigner: {
      readonly __typename: string;
      readonly id?: string;
      readonly login: string;
    } | null | undefined;
  }>;
  readonly assignedActors: {
    readonly nodes: ReadonlyArray<{
      readonly __typename?: string;
      readonly avatarUrl?: string;
      readonly displayName?: string;
      readonly id?: string;
      readonly isAgent?: boolean;
      readonly isCopilot?: boolean;
      readonly login?: string;
      readonly name?: string | null | undefined;
      readonly profileResourcePath?: string | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly author: {
    readonly __typename: string;
    readonly avatarUrl: string;
    readonly id: string;
    readonly isAgent?: boolean;
    readonly isCopilot?: boolean;
    readonly login: string;
    readonly name?: string | null | undefined;
    readonly profileUrl: string | null | undefined;
  } | null | undefined;
  readonly body: string;
  readonly bodyHTML: string;
  readonly bodyVersion: string;
  readonly closedByPullRequestsReferences: {
    readonly nodes: ReadonlyArray<{
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly state: PullRequestState;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly createdAt: string;
  readonly databaseId: number | null | undefined;
  readonly duplicateOf: {
    readonly number: number;
    readonly repository: {
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly url: string;
  } | null | undefined;
  readonly id: string;
  readonly isPinned: boolean | null | undefined;
  readonly issueFieldValues: {
    readonly nodes: ReadonlyArray<{
      readonly color?: IssueFieldSingleSelectOptionColor;
      readonly description?: string | null | undefined;
      readonly field?: {
        readonly dataType?: IssueFieldDataType;
        readonly id?: string;
        readonly name?: string;
        readonly visibility?: IssueFieldVisibility;
      } | null | undefined;
      readonly multiSelectValue?: string | null | undefined;
      readonly name?: string;
      readonly numberValue?: number;
      readonly optionId?: string | null | undefined;
      readonly options?: ReadonlyArray<{
        readonly color: IssueFieldSingleSelectOptionColor;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly name: string;
      }>;
      readonly value?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly issueType: {
    readonly color: IssueTypeColor;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
    readonly pinnedFields: ReadonlyArray<{
      readonly __typename: "IssueFieldDate";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldMultiSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldNumber";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldSingleSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldText";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null | undefined;
  } | null | undefined;
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly archivedAt: string | null | undefined;
        readonly color: string;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly nameHTML: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly linkedPullRequests: {
    readonly nodes: ReadonlyArray<{
      readonly isDraft: boolean;
      readonly number: number;
      readonly repository: {
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly state: PullRequestState;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly locked: boolean;
  readonly milestone: {
    readonly closed: boolean;
    readonly closedAt: string | null | undefined;
    readonly dueOn: string | null | undefined;
    readonly id: string;
    readonly progressPercentage: number;
    readonly title: string;
    readonly url: string;
  } | null | undefined;
  readonly number: number;
  readonly pendingBlock: boolean | null | undefined;
  readonly pendingSuggestions: ReadonlyArray<{
    readonly __typename: "PendingAssigneeSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
      readonly name: string | null | undefined;
      readonly resourcePath: string;
    } | null | undefined;
    readonly assignee: {
      readonly __typename: string;
      readonly avatarUrl?: string;
      readonly displayName?: string;
      readonly id?: string;
      readonly isAgent?: boolean;
      readonly login?: string;
    } | null | undefined;
    readonly assigneeState: PendingIssueSuggestionState;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly createdAt: string;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly rationale: string | null | undefined;
  } | {
    readonly __typename: "PendingCloseSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
      readonly name: string | null | undefined;
      readonly resourcePath: string;
    } | null | undefined;
    readonly closeState: PendingIssueSuggestionState;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly createdAt: string;
    readonly duplicateOf: {
      readonly __typename: "Issue";
      readonly number: number;
      readonly repository: {
        readonly nameWithOwner: string;
      };
      readonly title: string;
      readonly url: string;
    } | {
      readonly __typename: "PullRequest";
      readonly number: number;
      readonly repository: {
        readonly nameWithOwner: string;
      };
      readonly title: string;
      readonly url: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly rationale: string | null | undefined;
    readonly stateReason: IssueStateReason | null | undefined;
  } | {
    readonly __typename: "PendingFieldSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
      readonly name: string | null | undefined;
      readonly resourcePath: string;
    } | null | undefined;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly createdAt: string;
    readonly fieldState: PendingIssueSuggestionState;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly issueField: {
      readonly __typename: string;
      readonly id?: string;
      readonly name?: string;
      readonly options?: ReadonlyArray<{
        readonly color: IssueFieldSingleSelectOptionColor;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly rationale: string | null | undefined;
    readonly suggestedValue: string | null | undefined;
  } | {
    readonly __typename: "PendingLabelSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
      readonly name: string | null | undefined;
      readonly resourcePath: string;
    } | null | undefined;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly createdAt: string;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly label: {
      readonly color: string;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly labelState: PendingIssueSuggestionState;
    readonly rationale: string | null | undefined;
  } | {
    readonly __typename: "PendingTypeSuggestion";
    readonly actor: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly displayName?: string;
      readonly id: string;
      readonly login: string;
      readonly name: string | null | undefined;
      readonly resourcePath: string;
    } | null | undefined;
    readonly confidence: IssueEventConfidenceLevel | null | undefined;
    readonly createdAt: string;
    readonly intent: {
      readonly intentId: string | null | undefined;
    } | null | undefined;
    readonly issueType: {
      readonly color: IssueTypeColor;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly rationale: string | null | undefined;
    readonly typeState: PendingIssueSuggestionState;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }> | null | undefined;
  readonly pendingUnblock: boolean | null | undefined;
  readonly pinnedIssueComment: {
    readonly issueComment: {
      readonly author: {
        readonly avatarUrl: string;
        readonly login: string;
        readonly profileUrl: string | null | undefined;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly shortBodyHTML: string;
      readonly url: string;
      readonly viewerCanUnpin: boolean;
    };
    readonly pinnedBy: {
      readonly login: string;
    };
  } | null | undefined;
  readonly projectItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldValueByName: {
          readonly color?: ProjectV2SingleSelectFieldOptionColor;
          readonly id?: string;
          readonly name?: string | null | undefined;
          readonly nameHTML?: string | null | undefined;
          readonly optionId?: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly isArchived: boolean;
        readonly project: {
          readonly closed: boolean;
          readonly field: {
            readonly databaseId?: number | null | undefined;
            readonly id?: string;
            readonly name?: string;
            readonly options?: ReadonlyArray<{
              readonly color: ProjectV2SingleSelectFieldOptionColor;
              readonly description: string;
              readonly descriptionHTML: string;
              readonly id: string;
              readonly name: string;
              readonly nameHTML: string;
              readonly optionId: string;
            }>;
          } | null | undefined;
          readonly hasReachedItemsLimit: boolean;
          readonly id: string;
          readonly number: number;
          readonly template: boolean;
          readonly title: string;
          readonly url: string;
          readonly viewerCanUpdate: boolean;
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly reactionGroups: ReadonlyArray<{
    readonly content: ReactionContent;
    readonly reactors: {
      readonly nodes: ReadonlyArray<{
        readonly __typename: string;
        readonly avatarUrl?: string;
        readonly displayName?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login?: string;
        readonly name?: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly totalCount: number;
    };
    readonly viewerHasReacted: boolean;
  }> | null | undefined;
  readonly repository: {
    readonly databaseId: number | null | undefined;
    readonly id: string;
    readonly isArchived: boolean;
    readonly isCopilotAgentEnabled: boolean | null | undefined;
    readonly isOwnerEnterpriseManaged: boolean | null | undefined;
    readonly isPrivate: boolean;
    readonly isWritable: boolean;
    readonly issueTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly nameWithOwner: string;
    readonly owner: {
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly issueFields?: {
        readonly totalCount: number;
      } | null | undefined;
      readonly issueFieldsEnabled: boolean;
      readonly login: string;
      readonly pinnedIssueFields?: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "IssueFieldDate";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldMultiSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldNumber";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldSingleSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldText";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly url: string;
    };
    readonly pinnedIssues: {
      readonly totalCount: number;
    } | null | undefined;
    readonly slashCommandsEnabled: boolean;
    readonly viewerCanInteract: boolean;
    readonly viewerCanPinIssues: boolean;
    readonly viewerCanPush: boolean;
    readonly viewerInteractionLimitReasonHTML: string | null | undefined;
    readonly viewerIssueCreationPermissions: {
      readonly triageable: boolean;
    };
    readonly visibility: RepositoryVisibility;
  };
  readonly state: IssueState;
  readonly stateReason: IssueStateReason | null | undefined;
  readonly subIssuesSummary: {
    readonly completed: number;
    readonly total: number;
  };
  readonly timeline?: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineIssueFragment">;
  } | null | undefined;
  readonly title: string;
  readonly titleHTML: string;
  readonly updatedAt: string;
  readonly url: string;
  readonly viewerCanAssign: boolean;
  readonly viewerCanComment: boolean;
  readonly viewerCanConvertToDiscussion: boolean | null | undefined;
  readonly viewerCanDelete: boolean;
  readonly viewerCanLabel: boolean;
  readonly viewerCanLock: boolean | null | undefined;
  readonly viewerCanSetFields: boolean | null | undefined;
  readonly viewerCanSetMilestone: boolean;
  readonly viewerCanTransfer: boolean;
  readonly viewerCanType: boolean | null | undefined;
  readonly viewerCanUpdateMetadata: boolean | null | undefined;
  readonly viewerCanUpdateNext: boolean | null | undefined;
  readonly viewerDidAuthor: boolean;
  readonly " $fragmentType": "IssueViewerIssue";
};
export type IssueViewerIssue$key = {
  readonly " $data"?: IssueViewerIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueViewerIssue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = [
  (v9/*:: as any*/)
],
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v12 = [
  (v11/*:: as any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  (v0/*:: as any*/),
  (v3/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  },
  (v6/*:: as any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*:: as any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*:: as any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v14/*:: as any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": (v14/*:: as any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v14/*:: as any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v20 = [
  (v13/*:: as any*/),
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/),
  (v18/*:: as any*/),
  (v19/*:: as any*/)
],
v21 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "IssueFieldsConnection",
    "kind": "LinkedField",
    "name": "issueFields",
    "plural": false,
    "selections": (v10/*:: as any*/),
    "storageKey": "issueFields(first:1)"
  },
  {
    "alias": null,
    "args": (v12/*:: as any*/),
    "concreteType": "IssueFieldsConnection",
    "kind": "LinkedField",
    "name": "pinnedIssueFields",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": (v20/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": "pinnedIssueFields(first:100)"
  }
],
v22 = [
  (v0/*:: as any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v25 = [
  (v7/*:: as any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v25/*:: as any*/),
  "storageKey": null
},
v27 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v22/*:: as any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*:: as any*/),
    (v31/*:: as any*/),
    (v32/*:: as any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v44 = [
  (v3/*:: as any*/)
],
v45 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "intentId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v13/*:: as any*/),
    (v7/*:: as any*/),
    (v3/*:: as any*/),
    (v42/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourcePath",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v32/*:: as any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rationale",
  "storageKey": null
},
v52 = [
  (v0/*:: as any*/),
  (v3/*:: as any*/),
  (v23/*:: as any*/)
],
v53 = [
  (v1/*:: as any*/),
  (v37/*:: as any*/),
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Repository",
    "kind": "LinkedField",
    "name": "repository",
    "plural": false,
    "selections": [
      (v5/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "allowedOwner"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hideTimeline"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectItems"
        ]
      }
    ]
  },
  "name": "IssueViewerIssue",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateMetadata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanInteract",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerInteractionLimitReasonHTML",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slashCommandsEnabled",
          "storageKey": null
        },
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanPush",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v7/*:: as any*/),
            (v0/*:: as any*/),
            (v8/*:: as any*/),
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "issueFieldsEnabled",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v21/*:: as any*/),
              "type": "Organization",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v21/*:: as any*/),
              "type": "User",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isWritable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOwnerEnterpriseManaged",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanPinIssues",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCopilotAgentEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v12/*:: as any*/),
          "concreteType": "IssueTypeConnection",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IssueType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v22/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "issueTypes(first:100)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }
          ],
          "concreteType": "PinnedIssueConnection",
          "kind": "LinkedField",
          "name": "pinnedIssues",
          "plural": false,
          "selections": (v10/*:: as any*/),
          "storageKey": "pinnedIssues(first:3)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueCreationPermissions",
          "kind": "LinkedField",
          "name": "viewerIssueCreationPermissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "triageable",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleHTML",
      "storageKey": null
    },
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateNext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        (v23/*:: as any*/),
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        },
        (v24/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "pinnedFields",
          "plural": true,
          "selections": (v20/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "duplicateOf",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        (v8/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v3/*:: as any*/),
            (v26/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "linkedPullRequests",
      "args": [
        (v27/*:: as any*/),
        {
          "kind": "Literal",
          "name": "includeClosedPrs",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "orderByState",
          "value": true
        }
      ],
      "concreteType": "PullRequestConnection",
      "kind": "LinkedField",
      "name": "closedByPullRequestsReferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PullRequest",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                (v5/*:: as any*/),
                (v26/*:: as any*/)
              ],
              "storageKey": null
            },
            (v8/*:: as any*/),
            (v1/*:: as any*/),
            (v28/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDraft",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentAssignment",
      "kind": "LinkedField",
      "name": "agentAssignments",
      "plural": true,
      "selections": [
        (v13/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Bot",
          "kind": "LinkedField",
          "name": "assignee",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v7/*:: as any*/),
            (v29/*:: as any*/),
            (v30/*:: as any*/),
            (v31/*:: as any*/),
            (v32/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "assigner",
          "plural": false,
          "selections": [
            (v13/*:: as any*/),
            (v33/*:: as any*/),
            (v7/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v27/*:: as any*/),
        {
          "kind": "Literal",
          "name": "includeClosedPrs",
          "value": true
        }
      ],
      "concreteType": "PullRequestConnection",
      "kind": "LinkedField",
      "name": "closedByPullRequestsReferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PullRequest",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v8/*:: as any*/),
            (v28/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
    },
    {
      "alias": null,
      "args": [
        (v11/*:: as any*/),
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASC",
            "field": "NAME"
          }
        }
      ],
      "concreteType": "LabelConnection",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            (v34/*:: as any*/),
            (v35/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v23/*:: as any*/),
                (v3/*:: as any*/),
                (v36/*:: as any*/),
                (v24/*:: as any*/),
                (v8/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "archivedAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Milestone",
      "kind": "LinkedField",
      "name": "milestone",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v37/*:: as any*/),
        (v38/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dueOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "progressPercentage",
          "storageKey": null
        },
        (v8/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "AssigneeConnection",
      "kind": "LinkedField",
      "name": "assignedActors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v13/*:: as any*/),
                (v0/*:: as any*/),
                (v7/*:: as any*/),
                (v3/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileResourcePath",
                  "storageKey": null
                },
                (v29/*:: as any*/),
                (v39/*:: as any*/)
              ],
              "type": "Actor",
              "abstractKey": "__isActor"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "assignedActors(first:20)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanComment",
      "storageKey": null
    },
    (v2/*:: as any*/),
    (v28/*:: as any*/),
    (v40/*:: as any*/),
    (v37/*:: as any*/),
    (v41/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerDidAuthor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v42/*:: as any*/),
        (v7/*:: as any*/),
        (v0/*:: as any*/),
        (v43/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": (v44/*:: as any*/),
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v44/*:: as any*/),
          "type": "EnterpriseUserAccount",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v44/*:: as any*/),
          "type": "Mannequin",
          "abstractKey": null
        },
        (v13/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v30/*:: as any*/),
            (v31/*:: as any*/)
          ],
          "type": "Bot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unfurlReferences",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "bodyHTML",
      "storageKey": "bodyHTML(unfurlReferences:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bodyVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionGroup",
      "kind": "LinkedField",
      "name": "reactionGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerHasReacted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v27/*:: as any*/)
          ],
          "concreteType": "ReactorConnection",
          "kind": "LinkedField",
          "name": "reactors",
          "plural": false,
          "selections": [
            (v9/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v13/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v7/*:: as any*/),
                    (v3/*:: as any*/),
                    (v29/*:: as any*/),
                    (v39/*:: as any*/)
                  ],
                  "type": "Actor",
                  "abstractKey": "__isActor"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "reactors(first:10)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PinnedIssueComment",
      "kind": "LinkedField",
      "name": "pinnedIssueComment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "pinnedBy",
          "plural": false,
          "selections": (v25/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueComment",
          "kind": "LinkedField",
          "name": "issueComment",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 700
                },
                {
                  "kind": "Literal",
                  "name": "stripBlockElements",
                  "value": false
                }
              ],
              "kind": "ScalarField",
              "name": "shortBodyHTML",
              "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
            },
            (v41/*:: as any*/),
            (v8/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnpin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v7/*:: as any*/),
                (v42/*:: as any*/),
                (v43/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanAssign",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanLabel",
      "storageKey": null
    },
    {
      "alias": "projectItems",
      "args": [
        {
          "kind": "Literal",
          "name": "allowSameEnterprise",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "allowedOwner",
          "variableName": "allowedOwner"
        }
      ],
      "concreteType": "ProjectV2ItemConnection",
      "kind": "LinkedField",
      "name": "__ProjectSection_projectItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2ItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v4/*:: as any*/),
                {
                  "alias": null,
                  "args": (v45/*:: as any*/),
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "fieldValueByName",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*:: as any*/),
                        (v46/*:: as any*/),
                        (v3/*:: as any*/),
                        (v36/*:: as any*/),
                        (v23/*:: as any*/)
                      ],
                      "type": "ProjectV2ItemFieldSingleSelectValue",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": "fieldValueByName(name:\"Status\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectV2",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v37/*:: as any*/),
                    (v38/*:: as any*/),
                    (v1/*:: as any*/),
                    (v8/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "template",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerCanUpdate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasReachedItemsLimit",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": (v45/*:: as any*/),
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*:: as any*/),
                            (v0/*:: as any*/),
                            (v3/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProjectV2SingleSelectFieldOption",
                              "kind": "LinkedField",
                              "name": "options",
                              "plural": true,
                              "selections": [
                                (v0/*:: as any*/),
                                (v46/*:: as any*/),
                                (v3/*:: as any*/),
                                (v36/*:: as any*/),
                                (v23/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "descriptionHTML",
                                  "storageKey": null
                                },
                                (v24/*:: as any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "ProjectV2SingleSelectField",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": "field(name:\"Status\")"
                    }
                  ],
                  "storageKey": null
                },
                (v13/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            (v35/*:: as any*/),
            (v34/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSetMilestone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPinned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanDelete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanTransfer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanConvertToDiscussion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanLock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSetFields",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 25
        }
      ],
      "concreteType": "IssueFieldValueConnection",
      "kind": "LinkedField",
      "name": "issueFieldValues",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v15/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v47/*:: as any*/)
              ],
              "type": "IssueFieldTextValue",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v16/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v46/*:: as any*/),
                (v3/*:: as any*/),
                (v23/*:: as any*/),
                (v24/*:: as any*/)
              ],
              "type": "IssueFieldSingleSelectValue",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v17/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IssueFieldSingleSelectOption",
                  "kind": "LinkedField",
                  "name": "options",
                  "plural": true,
                  "selections": [
                    (v0/*:: as any*/),
                    (v3/*:: as any*/),
                    (v23/*:: as any*/),
                    (v24/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "multiSelectValue",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "IssueFieldMultiSelectValue",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v18/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v47/*:: as any*/)
              ],
              "type": "IssueFieldDateValue",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v19/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "numberValue",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "type": "IssueFieldNumberValue",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "issueFieldValues(first:25)"
    },
    {
      "condition": "hideTimeline",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                  },
                  {
                    "kind": "Variable",
                    "name": "skip",
                    "variableName": "skip"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "IssueTimelineIssueFragment"
              }
            ],
            "type": "Issue",
            "abstractKey": null
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "timeline"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SubIssuesSummary",
      "kind": "LinkedField",
      "name": "subIssuesSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pendingSuggestions",
      "plural": true,
      "selections": [
        (v13/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "typeState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v41/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            (v50/*:: as any*/),
            (v51/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": (v52/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "PendingTypeSuggestion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "labelState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v41/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            (v50/*:: as any*/),
            (v51/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "label",
              "plural": false,
              "selections": (v52/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "PendingLabelSuggestion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "fieldState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v41/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            (v51/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "suggestedValue",
              "storageKey": null
            },
            (v50/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "issueField",
              "plural": false,
              "selections": [
                (v13/*:: as any*/),
                (v33/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v44/*:: as any*/),
                  "type": "IssueFieldCommon",
                  "abstractKey": "__isIssueFieldCommon"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IssueFieldSingleSelectOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": [
                        (v3/*:: as any*/),
                        (v23/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFieldSingleSelect",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PendingFieldSuggestion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "closeState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v41/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            (v51/*:: as any*/),
            (v50/*:: as any*/),
            (v40/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicateOf",
              "plural": false,
              "selections": [
                (v13/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v53/*:: as any*/),
                  "type": "Issue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v53/*:: as any*/),
                  "type": "PullRequest",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PendingCloseSuggestion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "assigneeState",
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            (v41/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            (v50/*:: as any*/),
            (v51/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": [
                (v13/*:: as any*/),
                (v33/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v7/*:: as any*/),
                    (v32/*:: as any*/),
                    (v42/*:: as any*/)
                  ],
                  "type": "Actor",
                  "abstractKey": "__isActor"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v31/*:: as any*/)
                  ],
                  "type": "Bot",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PendingAssigneeSuggestion",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingBlock",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingUnblock",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "f0ed080921d3bdcf90197259919da49a";

export default node;
